import React from "react"
import { AppLink } from "@app"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"


export default function AppButtonLink({ to, icon, tooltip, isLoading=false, ...props }) {
	return <AppLink to={to}>
		<ButtonLoadingSeeker
			variant="outlined"
			color="secondary"
			size="small"
			loading={isLoading}
			{...props}
			sx={{ 
				p: 0,
				minWidth: 0,
				width: 22,
				height: 22,
				fontSize: "0.80rem",
				...props?.sx
			 }}
		>
			<IconSeeker icon={icon} iconWeight="light" tooltip={tooltip} {...props.iconProps} />
		</ButtonLoadingSeeker>
	</AppLink>
}